/* eslint-disable */
import { useEffect, useState, useRef, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faSearch,
  faSortUp,
  faSortDown,
  faSort,
  faRefresh,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { API_URL } from "../config.js";
import { PermissionWrapper, getRoleDetails, getRoleUserid } from "../helpers/permission.js";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { showToast } from "../components/toast.jsx";
import "../Subscriber/subscribe.css";
import MultiSelectDropdown from "../Subscriber/MultiSelectDropdown.jsx";
import "../Subscriber/MultiSelectDropdown.css";
import useDoubleScroll from "../helpers/useDoubleScroll";

// Field permission wrapper supporting both subscriber_portfolio_* and subscriber_* permissions
const FieldPermissionWrapper = ({ field, children }) => {
  const roleUserId = getRoleUserid();
  if (roleUserId == "1") return children;
  const roleDetails = getRoleDetails();
  const subField = field ? field.replace("subscriber_portfolio_", "subscriber_") : "";
  if (roleDetails && roleDetails[field]) {
    return roleDetails[field]?.view === "1" ? children : null;
  }
  if (subField && roleDetails && roleDetails[subField]) {
    return roleDetails[subField]?.view === "1" ? children : null;
  }
  return children;
};


const SubscriberPortfolio = () => {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  // Data states
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 100;
  const [selectedSubscribers, setSelectedSubscribers] = useState([]);

  // Sorting
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");

  // Top header action menu & search
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);
  const actionMenuRef = useRef(null);
  const [mobileSearchInput, setMobileSearchInput] = useState("");

  // In-header column filters (identical to Subscriber module)
  const [createdDateRange, setCreatedDateRange] = useState([null, null]);
  const [leadSourceFilter, setLeadSourceFilter] = useState([]);
  const [nameFilter, setNameFilter] = useState("");
  const [mobileFilter, setMobileFilter] = useState("");
  const [altMobileFilter, setAltMobileFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [leadStatusFilter, setLeadStatusFilter] = useState([]);
  const [leadResponseFilter, setLeadResponseFilter] = useState([]);
  const [subscribedFilter, setSubscribedFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [recentContactedDateRange, setRecentContactedDateRange] = useState([null, null]);
  const [utmSourceFilter, setUtmSourceFilter] = useState("");
  const [utmMediumFilter, setUtmMediumFilter] = useState("");
  const [utmCampaignFilter, setUtmCampaignFilter] = useState("");
  const [utmContentFilter, setUtmContentFilter] = useState("");
  const [utmTermFilter, setUtmTermFilter] = useState("");
  const [clickidFilter, setClickidFilter] = useState("");
  const [clicktypeFilter, setClicktypeFilter] = useState("");

  // Dropdown options
  const [dropdownOptions, setDropdownOptions] = useState({
    leadSources: [],
    leadStatuses: [],
    leadResponses: [],
    statuses: [],
    subscribedOptions: [],
  });

  // Table scroll refs
  const tableContainerRef = useRef(null);
  const topScrollRef = useDoubleScroll(tableContainerRef);

  // Close action menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setIsActionMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch dropdown filter options
  const fetchDropdowns = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}subscriber-portfolio/get-dropdown`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.data) {
        setDropdownOptions(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching dropdowns:", err);
    }
  }, [token]);

  // Build filter params for API
  const buildFilterParams = useCallback(() => {
    const params = {};

    if (mobileSearchInput && mobileSearchInput.trim()) {
      params.search = mobileSearchInput.trim();
    }
    if (createdDateRange[0]) {
      params.screated_on = moment(createdDateRange[0]).format("YYYY-MM-DD");
    }
    if (createdDateRange[1]) {
      params.ecreated_on = moment(createdDateRange[1]).format("YYYY-MM-DD");
    }
    if (leadSourceFilter && leadSourceFilter.length > 0) {
      params.lead_source = leadSourceFilter;
    }
    if (nameFilter && nameFilter.trim()) {
      params.fullname = nameFilter.trim();
    }
    if (mobileFilter && mobileFilter.trim()) {
      params.mobileno = mobileFilter.trim();
    }
    if (altMobileFilter && altMobileFilter.trim()) {
      params.otherphone = altMobileFilter.trim();
    }
    if (emailFilter && emailFilter.trim()) {
      params.email = emailFilter.trim();
    }
    if (leadStatusFilter && leadStatusFilter.length > 0) {
      params.lead_status = leadStatusFilter;
    }
    if (leadResponseFilter && leadResponseFilter.length > 0) {
      params.lead_response = leadResponseFilter;
    }
    if (subscribedFilter && subscribedFilter.length > 0) {
      params.subscribed = subscribedFilter;
    }
    if (statusFilter && statusFilter.length > 0) {
      params.status = statusFilter;
    }
    if (recentContactedDateRange[0]) {
      params.srecent_contacted = moment(recentContactedDateRange[0]).format("YYYY-MM-DD");
    }
    if (recentContactedDateRange[1]) {
      params.erecent_contacted = moment(recentContactedDateRange[1]).format("YYYY-MM-DD");
    }
    if (utmSourceFilter && utmSourceFilter.trim()) {
      params.utm_source = utmSourceFilter.trim();
    }
    if (utmMediumFilter && utmMediumFilter.trim()) {
      params.utm_medium = utmMediumFilter.trim();
    }
    if (utmCampaignFilter && utmCampaignFilter.trim()) {
      params.utm_campaign = utmCampaignFilter.trim();
    }
    if (utmContentFilter && utmContentFilter.trim()) {
      params.utm_content = utmContentFilter.trim();
    }
    if (utmTermFilter && utmTermFilter.trim()) {
      params.utm_term = utmTermFilter.trim();
    }
    if (clickidFilter && clickidFilter.trim()) {
      params.clickid = clickidFilter.trim();
    }
    if (clicktypeFilter && clicktypeFilter.trim()) {
      params.clicktype = clicktypeFilter.trim();
    }
    if (sortField) {
      params.orderbycol = sortField;
    }
    if (sortOrder) {
      params.orderby = sortOrder;
    }

    return params;
  }, [
    mobileSearchInput,
    createdDateRange,
    leadSourceFilter,
    nameFilter,
    mobileFilter,
    altMobileFilter,
    emailFilter,
    leadStatusFilter,
    leadResponseFilter,
    subscribedFilter,
    statusFilter,
    recentContactedDateRange,
    utmSourceFilter,
    utmMediumFilter,
    utmCampaignFilter,
    utmContentFilter,
    utmTermFilter,
    clickidFilter,
    clicktypeFilter,
    sortField,
    sortOrder,
  ]);

  // Fetch list & count
  const fetchSubscribers = useCallback(
    async (pageNumber = 1, currentFilters = null) => {
      try {
        setLoading(true);
        const filterParams = currentFilters || buildFilterParams();

        const [listRes, countRes] = await Promise.all([
          axios.post(
            `${API_URL}subscriber-portfolio/list?page=${pageNumber}&limit=${limit}`,
            filterParams,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          ),
          axios.post(`${API_URL}subscriber-portfolio/count`, filterParams, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
        ]);

        if (listRes.data?.data) {
          const list = listRes.data.data.subscribers || (Array.isArray(listRes.data.data) ? listRes.data.data : []);
          setUsers(Array.isArray(list) ? list : []);
        }
        if (countRes.data?.data) {
          const total = countRes.data.data.total ?? (typeof countRes.data.data === 'number' ? countRes.data.data : 0);
          setTotalCount(total);
        }
        setPage(pageNumber);
        setSelectedSubscribers([]);
      } catch (err) {
        console.error("Error fetching subscriber portfolio:", err);
        showToast.error("Failed to load subscriber portfolio data");
      } finally {
        setLoading(false);
      }
    },
    [buildFilterParams, limit, token]
  );

  useEffect(() => {
    fetchDropdowns();
  }, [fetchDropdowns]);

  useEffect(() => {
    fetchSubscribers(1);
  }, [fetchSubscribers]);

  // Check if any filter is applied
  const hasAnyFilter = () => {
    return (
      (mobileSearchInput && mobileSearchInput.trim() !== "") ||
      createdDateRange[0] !== null ||
      createdDateRange[1] !== null ||
      leadSourceFilter.length > 0 ||
      (nameFilter && nameFilter.trim() !== "") ||
      (mobileFilter && mobileFilter.trim() !== "") ||
      (altMobileFilter && altMobileFilter.trim() !== "") ||
      (emailFilter && emailFilter.trim() !== "") ||
      leadStatusFilter.length > 0 ||
      leadResponseFilter.length > 0 ||
      subscribedFilter.length > 0 ||
      statusFilter.length > 0 ||
      recentContactedDateRange[0] !== null ||
      recentContactedDateRange[1] !== null ||
      (utmSourceFilter && utmSourceFilter.trim() !== "") ||
      (utmMediumFilter && utmMediumFilter.trim() !== "") ||
      (utmCampaignFilter && utmCampaignFilter.trim() !== "") ||
      (utmContentFilter && utmContentFilter.trim() !== "") ||
      (utmTermFilter && utmTermFilter.trim() !== "") ||
      (clickidFilter && clickidFilter.trim() !== "") ||
      (clicktypeFilter && clicktypeFilter.trim() !== "")
    );
  };

  // Clear all filters
  const clearAllFilters = () => {
    setMobileSearchInput("");
    setCreatedDateRange([null, null]);
    setLeadSourceFilter([]);
    setNameFilter("");
    setMobileFilter("");
    setAltMobileFilter("");
    setEmailFilter("");
    setLeadStatusFilter([]);
    setLeadResponseFilter([]);
    setSubscribedFilter([]);
    setStatusFilter([]);
    setRecentContactedDateRange([null, null]);
    setUtmSourceFilter("");
    setUtmMediumFilter("");
    setUtmCampaignFilter("");
    setUtmContentFilter("");
    setUtmTermFilter("");
    setClickidFilter("");
    setClicktypeFilter("");

    fetchSubscribers(1, { orderbycol: sortField, orderby: sortOrder });
  };

  // Sorting
  const sortBox = (field) => {
    let newOrder = "asc";
    if (sortField === field) {
      newOrder = sortOrder === "asc" ? "desc" : "asc";
      setSortOrder(newOrder);
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
    const params = buildFilterParams();
    params.orderbycol = field;
    params.orderby = newOrder;
    fetchSubscribers(1, params);
  };

  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? faSortUp : faSortDown;
    }
    return faSort;
  };

  // Select all checkbox
  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = users.map((u) => u.id);
      setSelectedSubscribers(allIds);
    } else {
      setSelectedSubscribers([]);
    }
  };

  const handleSelectOne = (id, checked) => {
    if (checked) {
      setSelectedSubscribers((prev) => [...prev, id]);
    } else {
      setSelectedSubscribers((prev) => prev.filter((sId) => sId !== id));
    }
  };

  // Navigate to edit page
  const handleRowClick = (user) => {
    const targetId = user?.subscriber_main_id || user?.subscriberid || user?.id;
    if (targetId) {
      navigate(`/Subscriber/Edit/${targetId}`, {
        state: {
          userData: user,
          fromPortfolio: true,
        },
      });
    } else {
      showToast.warning("Subscriber ID not found for this record");
    }
  };

  // Export to CSV
  const handleExport = () => {
    if (!users || users.length === 0) {
      showToast.warning("No data to export");
      return;
    }

    const exportData =
      selectedSubscribers.length > 0
        ? users.filter((u) => selectedSubscribers.includes(u.id))
        : users;

    const headers = [
      "ID",
      "Created On",
      "Subscriber ID",
      "Lead Source",
      "Full Name",
      "Mobile No",
      "Alternate Mobile",
      "Email",
      "Lead Status",
      "Lead Response",
      "Subscribed",
      "Status",
      "Recent Contacted",
      "Contact Time",
      "Source",
      "OTP Verify Count",
      "Sign Up",
      "UTM Source",
      "UTM Medium",
      "UTM Campaign",
      "UTM Content",
      "UTM Term",
      "Click ID",
      "Click Type",
    ];

    const rows = exportData.map((u) => [
      u.id || "",
      u.created_on ? moment(u.created_on).format("YYYY-MM-DD HH:mm:ss") : "",
      u.subscriberid || "",
      u.lead_source || "",
      `"${(u.fullname || "").replace(/"/g, '""')}"`,
      u.mobileno || "",
      u.otherphone || "",
      u.email || "",
      u.lead_status || "",
      u.lead_response || "",
      u.subscribed || "",
      u.status || "",
      u.recent_contacted ? moment(u.recent_contacted).format("YYYY-MM-DD HH:mm:ss") : "",
      u.contact_time ? moment(u.contact_time).format("YYYY-MM-DD HH:mm:ss") : "",
      u.source ?? "",
      u.otp_verify_count ?? "",
      u.sign_up === 1 ? "Yes" : "No",
      u.utm_source || "",
      u.utm_medium || "",
      u.utm_campaign || "",
      u.utm_content || "",
      u.utm_term || "",
      u.clickid || "",
      u.clicktype || "",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((e) => e.join(","))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `subscriber_portfolio_${moment().format("YYYYMMDD_HHmmss")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleActionChange = (action) => {
    if (action === "bulkExport" || action === "export") {
      handleExport();
    }
  };

  // Pagination bounds
  const totalPages = Math.ceil(totalCount / limit) || 1;
  const start = totalCount === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalCount);

  // Map dropdown strings to { pick_name } format for MultiSelectDropdown
  const formatOptions = (list = []) =>
    list.map((item) => (typeof item === "string" ? { pick_name: item } : item));

  return (
    <div className="panel-content mt-5 panel-content-responsive">
      {/* Top Header matching Subscriber Module */}
      <div className="panel-heading subscriber-header-container pl-0 pr-0">
        <div className="header-action-search-row">
          {/* Action Select Box */}
          <div className="action-button-container" ref={actionMenuRef}>
            <div className="desktop-action-wrapper">
              <select
                value=""
                onChange={(e) => {
                  const selectedAction = e.target.value;
                  if (selectedAction) {
                    handleActionChange(selectedAction);
                  }
                }}
                className="action-select-box"
              >
                <option value="">Action</option>
                <PermissionWrapper module="subscriber_portfolio" action="export">
                  <option value="bulkExport">Bulk Export Data</option>
                </PermissionWrapper>
              </select>
            </div>

            <div className="mobile-action-dots-wrapper">
              <button
                className="btn btn-default btn-xs mobile-dots-btn"
                onClick={() => setIsActionMenuOpen(!isActionMenuOpen)}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} /> Action
              </button>
              {isActionMenuOpen && (
                <div className="mobile-action-dropdown">
                  <PermissionWrapper module="subscriber_portfolio" action="export">
                    <div
                      className="action-item"
                      onClick={() => {
                        handleActionChange("bulkExport");
                        setIsActionMenuOpen(false);
                      }}
                    >
                      Bulk Export Data
                    </div>
                  </PermissionWrapper>
                </div>
              )}
            </div>
          </div>

          {/* Search Box */}
          <div className="search-container-wrapper">
            <div className="search-box-flex">
              <input
                type="text"
                name="search_mob"
                id="search_mob"
                placeholder="Enter Mobile No. / Email ID / Name / UID"
                className="form-control subscriber-search-input"
                value={mobileSearchInput}
                onChange={(e) => setMobileSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchSubscribers(1);
                  }
                }}
              />
              <button
                className="btn btn-default btn-sm search-submit-btn"
                onClick={() => fetchSubscribers(1)}
                disabled={loading}
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
              {hasAnyFilter() && (
                <button
                  className="btn btn-default btn-xs clear-filters-btn"
                  onClick={clearAllFilters}
                  title="Clear all filters"
                >
                  Clear
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Header Pagination Row */}
        <div className="header-pagination-add-row">
          <div className="pagination-controls-wrapper">
            <span className="pagination-status-text">
              {loading ? (
                <span className="skeleton-text" style={{ width: "100px", display: "inline-block" }}></span>
              ) : (
                `${start} to ${end} of ${totalCount}`
              )}
            </span>
            <button
              className="btn btn-default btn-xs ms-1"
              onClick={() => fetchSubscribers(page)}
              title="Refresh"
            >
              <FontAwesomeIcon icon={faRefresh} spin={loading} />
            </button>
            <div className="pagination-nav-buttons">
              <button
                className={`btn btn-default btn-sm nav-prev-btn ${page === 1 ? "d-none" : ""}`}
                title="Previous"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <button
                className={`btn btn-default btn-sm nav-next-btn ${page >= totalPages ? "d-none" : ""}`}
                title="Next"
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= totalPages}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Table Container with Double Scrollbar */}
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="large-table-container-3">
          {/* Synchronized top horizontal scrollbar */}
          <div
            ref={topScrollRef}
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              height: "16px",
              marginBottom: "2px",
              background: "#f8f9fa",
            }}
          >
            <div style={{ width: "100%", height: "1px" }}></div>
          </div>

          {/* Main Table Scroll Container */}
          <div
            ref={tableContainerRef}
            style={{
              overflowY: "auto",
              height: "calc(112vh - 250px)",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <table className="table table-condensed table-hover bg-white sticky-table">
              <thead>
                {/* Header Row 1: Column Titles & Sort */}
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      checked={
                        users.length > 0 && selectedSubscribers.length === users.length
                      }
                    />
                  </th>
                  <FieldPermissionWrapper field="subscriber_portfolio_created_on">
                    <th
                      style={{ minWidth: "155px", cursor: "pointer" }}
                      onClick={() => sortBox("created_on")}
                    >
                      Created Time <FontAwesomeIcon icon={getSortIcon("created_on")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_source">
                    <th
                      style={{ cursor: "pointer", minWidth: "130px" }}
                      onClick={() => sortBox("lead_source")}
                    >
                      Lead Source <FontAwesomeIcon icon={getSortIcon("lead_source")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_fullname">
                    <th
                      style={{ cursor: "pointer", minWidth: "130px" }}
                      onClick={() => sortBox("fullname")}
                    >
                      Name <FontAwesomeIcon icon={getSortIcon("fullname")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_mobileno">
                    <th
                      style={{ cursor: "pointer", minWidth: "120px" }}
                      onClick={() => sortBox("mobileno")}
                    >
                      Mobile No <FontAwesomeIcon icon={getSortIcon("mobileno")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_otherphone">
                    <th
                      style={{ cursor: "pointer", minWidth: "120px" }}
                      onClick={() => sortBox("otherphone")}
                    >
                      Alternate No. <FontAwesomeIcon icon={getSortIcon("otherphone")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_email">
                    <th
                      style={{ cursor: "pointer", minWidth: "140px" }}
                      onClick={() => sortBox("email")}
                    >
                      Email <FontAwesomeIcon icon={getSortIcon("email")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_status">
                    <th
                      style={{ cursor: "pointer", minWidth: "130px" }}
                      onClick={() => sortBox("lead_status")}
                    >
                      Lead Status <FontAwesomeIcon icon={getSortIcon("lead_status")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_response">
                    <th
                      style={{ cursor: "pointer", minWidth: "130px" }}
                      onClick={() => sortBox("lead_response")}
                    >
                      Lead Response <FontAwesomeIcon icon={getSortIcon("lead_response")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_subscribed">
                    <th
                      style={{ cursor: "pointer", minWidth: "130px" }}
                      onClick={() => sortBox("subscribed")}
                    >
                      Subscribed <FontAwesomeIcon icon={getSortIcon("subscribed")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_status">
                    <th
                      style={{ cursor: "pointer", minWidth: "120px" }}
                      onClick={() => sortBox("status")}
                    >
                      Status <FontAwesomeIcon icon={getSortIcon("status")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_portfolio_recent_contacted">
                    <th
                      style={{ cursor: "pointer", minWidth: "155px" }}
                      onClick={() => sortBox("recent_contacted")}
                    >
                      Recent Contacted <FontAwesomeIcon icon={getSortIcon("recent_contacted")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th
                    style={{ cursor: "pointer", minWidth: "140px" }}
                    onClick={() => sortBox("contact_time")}
                  >
                    Contact Time <FontAwesomeIcon icon={getSortIcon("contact_time")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "90px" }}
                    onClick={() => sortBox("source")}
                  >
                    Source <FontAwesomeIcon icon={getSortIcon("source")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("otp_verify_count")}
                  >
                    OTP Count <FontAwesomeIcon icon={getSortIcon("otp_verify_count")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "90px" }}
                    onClick={() => sortBox("sign_up")}
                  >
                    Sign Up <FontAwesomeIcon icon={getSortIcon("sign_up")} />
                  </th>
                  <FieldPermissionWrapper field="subscriber_portfolio_utm_source">
                    <th
                      style={{ cursor: "pointer", minWidth: "120px" }}
                      onClick={() => sortBox("utm_source")}
                    >
                      UTM Source <FontAwesomeIcon icon={getSortIcon("utm_source")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("utm_medium")}
                  >
                    UTM Medium <FontAwesomeIcon icon={getSortIcon("utm_medium")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("utm_campaign")}
                  >
                    UTM Campaign <FontAwesomeIcon icon={getSortIcon("utm_campaign")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("utm_content")}
                  >
                    UTM Content <FontAwesomeIcon icon={getSortIcon("utm_content")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("utm_term")}
                  >
                    UTM Term <FontAwesomeIcon icon={getSortIcon("utm_term")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "120px" }}
                    onClick={() => sortBox("clickid")}
                  >
                    Click ID <FontAwesomeIcon icon={getSortIcon("clickid")} />
                  </th>
                  <th
                    style={{ cursor: "pointer", minWidth: "100px" }}
                    onClick={() => sortBox("clicktype")}
                  >
                    Click Type <FontAwesomeIcon icon={getSortIcon("clicktype")} />
                  </th>
                </tr>

                {/* Header Row 2: Inline Column Filters */}
                <tr>
                  <th></th>
                  {/* Created Time Range */}
                  <FieldPermissionWrapper field="subscriber_portfolio_created_on">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={createdDateRange[0]}
                            onChange={(dates) => setCreatedDateRange(dates || [null, null])}
                            startDate={createdDateRange[0]}
                            endDate={createdDateRange[1]}
                            selectsRange
                            isClearable
                            placeholderText=""
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => fetchSubscribers(1)}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>

                  {/* Lead Source */}
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_source">
                    <th>
                      <MultiSelectDropdown
                        options={formatOptions(dropdownOptions.leadSources)}
                        selectedValues={leadSourceFilter}
                        onChange={setLeadSourceFilter}
                        placeholder="--Select--"
                        onSearch={() => fetchSubscribers(1)}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Full Name */}
                  <FieldPermissionWrapper field="subscriber_portfolio_fullname">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={nameFilter}
                        onChange={(e) => setNameFilter(e.target.value)}
                        style={{ width: "90px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchSubscribers(1);
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Mobile No */}
                  <FieldPermissionWrapper field="subscriber_portfolio_mobileno">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={mobileFilter}
                        onChange={(e) => setMobileFilter(e.target.value)}
                        style={{ width: "95px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchSubscribers(1);
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Alternate No */}
                  <FieldPermissionWrapper field="subscriber_portfolio_otherphone">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={altMobileFilter}
                        onChange={(e) => setAltMobileFilter(e.target.value)}
                        style={{ width: "95px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchSubscribers(1);
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Email */}
                  <FieldPermissionWrapper field="subscriber_portfolio_email">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={emailFilter}
                        onChange={(e) => setEmailFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchSubscribers(1);
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Lead Status */}
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_status">
                    <th>
                      <MultiSelectDropdown
                        options={formatOptions(dropdownOptions.leadStatuses)}
                        selectedValues={leadStatusFilter}
                        onChange={setLeadStatusFilter}
                        placeholder="--Select--"
                        onSearch={() => fetchSubscribers(1)}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Lead Response */}
                  <FieldPermissionWrapper field="subscriber_portfolio_lead_response">
                    <th>
                      <MultiSelectDropdown
                        options={formatOptions(dropdownOptions.leadResponses)}
                        selectedValues={leadResponseFilter}
                        onChange={setLeadResponseFilter}
                        placeholder="--Select--"
                        onSearch={() => fetchSubscribers(1)}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Subscribed */}
                  <FieldPermissionWrapper field="subscriber_portfolio_subscribed">
                    <th>
                      <MultiSelectDropdown
                        options={formatOptions(dropdownOptions.subscribedOptions)}
                        selectedValues={subscribedFilter}
                        onChange={setSubscribedFilter}
                        placeholder="--Select--"
                        onSearch={() => fetchSubscribers(1)}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Status */}
                  <FieldPermissionWrapper field="subscriber_portfolio_status">
                    <th>
                      <MultiSelectDropdown
                        options={formatOptions(dropdownOptions.statuses)}
                        selectedValues={statusFilter}
                        onChange={setStatusFilter}
                        placeholder="--Select--"
                        onSearch={() => fetchSubscribers(1)}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* Recent Contacted Range */}
                  <FieldPermissionWrapper field="subscriber_portfolio_recent_contacted">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={recentContactedDateRange[0]}
                            onChange={(dates) =>
                              setRecentContactedDateRange(dates || [null, null])
                            }
                            startDate={recentContactedDateRange[0]}
                            endDate={recentContactedDateRange[1]}
                            selectsRange
                            isClearable
                            placeholderText=""
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => fetchSubscribers(1)}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>

                  {/* Contact Time */}
                  <th></th>

                  {/* Source */}
                  <th></th>

                  {/* OTP Count */}
                  <th></th>

                  {/* Sign Up */}
                  <th></th>

                  {/* UTM Source */}
                  <FieldPermissionWrapper field="subscriber_portfolio_utm_source">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={utmSourceFilter}
                        onChange={(e) => setUtmSourceFilter(e.target.value)}
                        style={{ width: "90px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") fetchSubscribers(1);
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  {/* UTM Medium */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={utmMediumFilter}
                      onChange={(e) => setUtmMediumFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>

                  {/* UTM Campaign */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={utmCampaignFilter}
                      onChange={(e) => setUtmCampaignFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>

                  {/* UTM Content */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={utmContentFilter}
                      onChange={(e) => setUtmContentFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>

                  {/* UTM Term */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={utmTermFilter}
                      onChange={(e) => setUtmTermFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>

                  {/* Click ID */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={clickidFilter}
                      onChange={(e) => setClickidFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>

                  {/* Click Type */}
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={clicktypeFilter}
                      onChange={(e) => setClicktypeFilter(e.target.value)}
                      style={{ width: "90px", padding: "5px" }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") fetchSubscribers(1);
                      }}
                    />
                  </th>
                </tr>
              </thead>

              {/* Table Body with Skeleton Loader */}
              <tbody>
                {loading ? (
                  Array.from({ length: 15 }).map((_, index) => (
                    <tr key={`skeleton-${index}`}>
                      <td>
                        <div
                          className="skeleton-text"
                          style={{ width: "16px", height: "16px" }}
                        ></div>
                      </td>
                      <FieldPermissionWrapper field="subscriber_portfolio_created_on">
                        <td><div className="skeleton-text" style={{ width: "120px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_lead_source">
                        <td><div className="skeleton-text" style={{ width: "90px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_fullname">
                        <td><div className="skeleton-text" style={{ width: "100px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_mobileno">
                        <td><div className="skeleton-text" style={{ width: "90px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_otherphone">
                        <td><div className="skeleton-text" style={{ width: "90px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_email">
                        <td><div className="skeleton-text" style={{ width: "120px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_lead_status">
                        <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_lead_response">
                        <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_subscribed">
                        <td><div className="skeleton-text" style={{ width: "90px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_status">
                        <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_portfolio_recent_contacted">
                        <td><div className="skeleton-text" style={{ width: "110px" }}></div></td>
                      </FieldPermissionWrapper>
                      <td><div className="skeleton-text" style={{ width: "110px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "50px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "50px" }}></div></td>
                      <FieldPermissionWrapper field="subscriber_portfolio_utm_source">
                        <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      </FieldPermissionWrapper>
                      <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "80px" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60px" }}></div></td>
                    </tr>
                  ))
                ) : !Array.isArray(users) || users.length === 0 ? (
                  <tr>
                    <td colSpan={23} className="text-center py-4 text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  users.map((user) => {
                    const isSelected = selectedSubscribers.includes(user.id);
                    return (
                      <tr
                        key={user.id}
                        className={user.sign_up === 1 ? "read-subscriber" : "unread-subscriber"}
                        onClick={() => handleRowClick(user)}
                        style={{ cursor: "pointer" }}
                      >
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => handleSelectOne(user.id, e.target.checked)}
                          />
                        </td>

                        <FieldPermissionWrapper field="subscriber_portfolio_created_on">
                          <td>
                            {user.created_on
                              ? moment(user.created_on).format("DD-MM-YYYY hh:mm A")
                              : "-"}
                          </td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_lead_source">
                          <td>{user.lead_source || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_fullname">
                          <td onClick={(e) => e.stopPropagation()}>
                            {user.subscriber_main_id || user.subscriberid || user.id ? (
                              <a
                                href={`/Subscriber/Edit/${user.subscriber_main_id || user.subscriberid || user.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#2563eb",
                                  textDecoration: "none",
                                  fontWeight: 500,
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration = "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration = "none")
                                }
                              >
                                {user.fullname || "-"}
                              </a>
                            ) : (
                              user.fullname || "-"
                            )}
                          </td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_mobileno">
                          <td>{user.mobileno || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_otherphone">
                          <td>{user.otherphone || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_email">
                          <td>{user.email || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_lead_status">
                          <td>{user.lead_status || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_lead_response">
                          <td>{user.lead_response || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_subscribed">
                          <td>{user.subscribed || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_status">
                          <td>{user.status || "-"}</td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_portfolio_recent_contacted">
                          <td>
                            {user.recent_contacted
                              ? moment(user.recent_contacted).format("DD-MM-YYYY hh:mm A")
                              : "-"}
                          </td>
                        </FieldPermissionWrapper>

                        <td>
                          {user.contact_time
                            ? moment(user.contact_time).format("DD-MM-YYYY hh:mm A")
                            : "-"}
                        </td>

                        <td>{user.source !== undefined && user.source !== null ? user.source : "-"}</td>

                        <td>{user.otp_verify_count ?? "-"}</td>

                        <td>{user.sign_up === 1 ? "Yes" : "No"}</td>

                        <FieldPermissionWrapper field="subscriber_portfolio_utm_source">
                          <td>{user.utm_source || "-"}</td>
                        </FieldPermissionWrapper>

                        <td>{user.utm_medium || "-"}</td>

                        <td>{user.utm_campaign || "-"}</td>

                        <td>{user.utm_content || "-"}</td>

                        <td>{user.utm_term || "-"}</td>

                        <td>{user.clickid || "-"}</td>

                        <td>{user.clicktype || "-"}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriberPortfolio;
